import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[labelSpacer]',
})
export class LabelSpacerDirective implements OnInit {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    const label = this.renderer.createElement('label');
    this.renderer.addClass(label, 'required');

    const span = this.renderer.createElement('span');
    this.renderer.addClass(span, 'is-required-asterisk');
    this.renderer.setProperty(span, 'innerHTML', '&nbsp;');
    this.renderer.appendChild(label, span);

    const firstChild = this.el.nativeElement.firstChild;
    if (firstChild) {
      this.renderer.insertBefore(this.el.nativeElement, label, firstChild);
    } else {
      this.renderer.appendChild(this.el.nativeElement, label);
    }
  }
}
